/**
 * ScrollEvents.js
 */

import $ from 'jquery';
import { gsap, ScrollTrigger, Power2 } from 'gsap/all';

export default class ScrollEvents {

    constructor() {

        this.scrollImages();

        this.staggeredCards();

        this.stackedCards();

        this.carousels();

    }

    staggeredCards() {
        const staggeredCardsContainer = $('.staggered-cards-container');
        staggeredCardsContainer.each((_, element) => {
            gsap.to(element, {
                duration: 1,
                scrollTrigger: {
                  trigger: element, // start the animation when ".box" enters the viewport (once)
                  start: 'top 100%',
                  end: 'top 50%',
                },
                top: -120,
            });
        })
    }

    carousels() {
        $('.scroll-slide-in').each((_, element) => {
            gsap.to(element, {
                duration: 1,
                ease: Power2.easeOut,
                scrollTrigger: {
                  trigger: element, // start the animation when ".box" enters the viewport (once)
                  start: 'top 40%',
                },
                x: 0,
            });
        });
    }

    scrollImages() {
        const fullImages = $('.image-full .lazy-load, .conclusion .lazy-load');

        fullImages.each((_, element) => {
            gsap.to(element, {
                duration: .5,
                scrollTrigger: {
                  trigger: element, // start the animation when ".box" enters the viewport (once)
                  start: 'top bottom',
                },
                scale: 1,
            });
        })
    }

    stackedCards() {
        $('.card-stack').each((_, element) => {
            ScrollTrigger.create({
                trigger: element,
                start: 'top 100%',
                end: 'top 50%',
                once: true,
                onEnter: self => {
                    element.classList.contains('unfanned') ? element.classList.remove('unfanned') : element.classList.add('unfanned');
                },
            });
        });
    }

}